module.exports = __webpack_public_path__ + "static/media/bantu_logo_transparent_white.78022b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bantu_logo_transparent_white.png
// module id = 813
// module chunks = 35